var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 19.7727L2.66667 13.1818L4.54667 11.31L9.33333 16.0423L19.4533 6.03728L21.3333 7.9091M21.3333 5.9713e-06H2.66667C1.18667 5.9713e-06 0 2.45138e-05 0 2.45138e-05V19.6805C0 20.59 0.466667 21.3941 1.17333 21.8686L12 29L22.8133 21.8686C23.52 21.3941 24 20.59 24 19.6805V0.297018C24 1.11176e-05 24 -5.9713e-06 23.3333 0C22.6667 5.9713e-06 22.0406 5.9713e-06 21.3333 5.9713e-06Z",
    fill: "#478CD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopTick);
export default __webpack_public_path__ + "static/media/topTick.ea7a1f60d40ea4a666e32668f4befbdc.svg";
export { ForwardRef as ReactComponent };